import chatmsg from "../components/chatmsg";
import utility from "./utility";
import request from "./curl";
import InfiniteLoading from 'vue-infinite-loading';
import confirmation_dialog from "../components/confirmation_dialog";
import media_utility from './media_utility';
const Entities = require('html-entities').XmlEntities;
const entities = new Entities();

export default {
  name: 'relevant',
  components: { chatmsg, InfiniteLoading, confirmation_dialog },
  data: () => ({
    loading: false,
    transition: 'scale-transition',
    relevant_messages: [],
    relevant_selected: true,
    relevant: [],
    grp: {},
    relevant_search: '',
    snackbar: false,
    err_msg: '',
    dialog: false,
    filtered_relevant_messages: [],
    new_interest: '',
    load_relevant: false,
    interests_dialog: false,
    relevantContainerStyleObj: {},
    group_name_search: '',
    selected_interest: 0,
    per_page: process.env.VUE_APP_APP_MESSAGE_PER_PAGE,
    headline: '',
    show_conf_dialog: false,
    message: '',
    delete_tag: {},
    infiniteId: +new Date(),
    data: [],
    first_time_loader: true,
    pagination_message_id: null,
    loader: false,
    page: 1,
    chat_grp_list: [],
    group_icon_data:{}
  }),
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
    async getChatgrpList() {
      this.chat_grp_list = await this.$store.getters.getChatgrpList;
      return this.chat_grp_list;
    },
    filteredRelevantOptions() {
      if (this.relevant && this.relevant.length > 0) {
        let self = this;
        return this.relevant.filter(function (option) {
          return option.toLowerCase().indexOf(self.relevant_search.toLowerCase()) >= 0;
        });
      }
      else {
        return this.relevant;
      }
    },
    relevantMessage() {
      return this.$store.getters.relevantMessage;
    },
    getClientDeviceHeight() {
      return this.$store.getters.getClientDeviceHeight;
    },
    getSearchBar() {
      if (this.$store.getters.getSearchBar) {
        this.$nextTick(() => {
          this.$refs.search_text.focus();
        })
      }
      return this.$store.getters.getSearchBar;
    },
    filteredRelevant() {
      if (this.relevant_messages && this.relevant_messages.length > 0) {
        return this.relevant_messages;
      }
    },
    async getUserContactList() {
      return await this.$store.getters.getUserContactList;
    },
    async getChatgrpIconList(){
      return await this.$store.getters.getChatgrpIconList;
    }
  },
  async mounted() {
    this.relevantContainerStyleObj = {
      height: (this.getClientDeviceHeight - 150) + 'px',
      //overflow:'hidden'
    };
    //Get interests from vue store and set them in relevant section on the right
    this.get_interests();
    this.$store.commit("setRelevantMessage", null);
    this.group_icon_data =  await this.getChatgrpIconList;

    if(this.group_icon_data == null){
      this.group_icon_data = {};
    }
  },
  updated() {

  },
  methods: {
    /**
    * get_interests
    */
    async get_interests() {
      var post_data = new FormData();
      post_data.append("user_id", this.userData.user_id);
      post_data.append("tag_type", 2);
      post_data.append("group_id", await this.selectedGroup);

      request.curl(this, "chat_tag_list", post_data)
      .then(response => {
        if (response.resp_status) {
          for (let index in response.resp_data) {
            this.relevant.push(response.resp_data[index].name);
          }
        }
      });
    },
    /**
     * get_relevant_from_api
     * 
     */
    async get_relevant_from_api($state) {
      let interest = '';
      if (this.selected_interest != -1 && this.relevant.length > 0) {
        interest = this.relevant[this.selected_interest];
      }
      else {
        if (this.relevant.length > 0) {
          interest = this.relevant[0];
        }
      }

      this.loader = true;
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);

      let groups = [];
      let chatgrpList = await this.getChatgrpList;
      for (let index in chatgrpList) {
        let grp = chatgrpList[index];
        groups.push('"' + grp.group_id + '"')
      }

      post_data.append("group_id", groups.join());
      post_data.append("all_relevant", true);
      post_data.append("per_page", this.per_page);//To limit how much message you want to load at every request
      post_data.append("tag_type", 2);
      post_data.append("tag_name", interest);
      post_data.append("pagination_type", 'page_index');
      post_data.append('page', this.page);

      request.curl(this, "message_list", post_data)
        .then(async response => {
          this.load_relevant = false;
          if (response.resp_status) {
            await this.relevant_messages.push(...response.resp_data.data);

            $state.loaded();
            if (this.relevant_messages.length == response.resp_data.total_count) {
              $state.complete();
            }
            this.first_time_loader = false;
            //cache.set_chatmsg_list_ls(group_id, response.resp_data);
            this.create_relevant(this.relevant_messages);
            this.page += 1;
          } 
          else {
            $state.complete();
            this.first_time_loader = false;
            this.loader = false;
          }
        });
    },
    /**
     * get_group_icon
     */
    get_group_icon(group_id) {
      for (let grp in this.chat_grp_list) {
        if (this.chat_grp_list[grp] && this.chat_grp_list[grp]['group_id'] == group_id) {
          let group = this.chat_grp_list[grp];
          return media_utility.get_group_icon(group, this.group_icon_data);
        }
      }
    },
    /**
     * get_group_name
     */
    get_group_name(group_id) {
      for (let grp in this.chat_grp_list) {
        if (this.chat_grp_list[grp] && this.chat_grp_list[grp]['group_id'] == group_id) {
          let group = this.chat_grp_list[grp];
          return group.group_name;
        }
      }
    },
    /**
     * get_msg_time
     * get formatted msg time
     */
    get_msg_time(ts) {
      return utility.get_message_datetime(ts, 'DD/MM/YYYY')
    },
    /**
     * get_formatted_name
     * Split on space and get the index0 of the name
     */
    get_formatted_name(grp_name) {
      let f_name = grp_name.substring(0, grp_name.indexOf(' '));
      if (!f_name) {
        return grp_name;
      }
      else {
        return f_name;
      }
    },
    /**
     * select_msg.
     * set relevant msg in store
     */
    select_msg(msg, group_id) {
      this.$store.commit("setSelectedGroup", group_id);
      this.$store.commit("setRelevantMessage", msg);
      this.$router.push('chat_message');
    },
    /**
     * add_interest.
     */
    add_interest() {
      this.loading = true;
      let ws = new RegExp(/^\s+$/);
      let re = /[^A-Z0-9]/gi;

      if (re.test(this.new_interest)) {
        this.snackbar = true;
        this.err_msg = 'Special characters are not allowed in tags';
        this.loading = false;
        return false;
      }

      if (this.new_interest && !ws.test(this.new_interest)) {
        let tag = '#' + this.new_interest;

        if (this.new_interest.length < 4) {
          this.snackbar = true;
          this.err_msg = 'Minimum tag length is 4 characters';
          this.loading = false;
          return false;
        }

        if (this.relevant.includes(tag.toLowerCase())) {
          this.snackbar = true;
          this.err_msg = 'Interest already exists.';
          this.loading = false;
          return false;
        }
        else {
          this.add_tag(tag);
          this.dialog = false;
          this.new_interest = '';
        }
      }
      else {
        this.snackbar = true;
        this.err_msg = 'Please type an interest';
      }
      this.loading = false;
    },
    /**
     * add_tag
     */
    add_tag(tag) {
      var post_data = new FormData();
      post_data.append("user_id", this.userData.user_id);
      post_data.append("tag_type", 2);
      post_data.append("tag_name", tag);

      request.curl(this, "chat_tag_add", post_data)
        .then(response => {
          if (response.resp_status) {
            this.relevant.push(tag);
            this.selected_interest += this.relevant.length - 1;
            this.err_msg = 'Interest Added.';
            this.snackbar = true;
          }
          else {
            this.err_msg = 'Unable to add interest';
            this.snackbar = true;
          }
        });
    },
    /**
     * create_relevant.
     * Create localstorage array for relevant messages if found.
     */
    create_relevant() {
      for (let index in this.relevant_messages) {
        let interest = '';
        if (this.selected_interest != -1) {
          interest = this.relevant[this.selected_interest];
        }
        else {
          interest = this.relevant[0];
        }
        let trim_int = interest.trim();
        let interest_wo_hash = trim_int.replace('#', '');
        this.relevant_messages[index].f_text_msg = this.get_colored_name(this.relevant_messages[index].text_msg, interest_wo_hash);
        this.relevant_messages[index].group_name = this.get_group_name(this.relevant_messages[index].group_id);
        this.relevant_messages[index].group_icon = this.get_group_icon(this.relevant_messages[index].group_id);
      }
      this.loader = false;
    },
    /**
     * get_colored_name.
     */
    get_colored_name(name, keyword) {
      let index = name.toLowerCase().indexOf(keyword.toLowerCase());
      let f_name = name.substring(0, index);
      let color_name = '<span class="mesh-text-color">' + name.substring(index, index + keyword.length) + '</span>';
      let l_name = name.substring(index + keyword.length);
      return f_name + color_name + l_name.substring(0, 20);
    },
    /**
     * cancel.
     */
    cancel() {
      this.new_interest = '';
      this.dialog = false;
      this.loading = false;
    },
    /**
     * tag_delete
     */
    tag_delete(index) {
      var post_data = new FormData();
      post_data.append("user_id", this.userData.user_id);
      post_data.append("tag_type", 2);
      post_data.append("tag_name", this.delete_tag);

      request.curl(this, "chat_tag_delete", post_data)
        .then(response => {
          if (response.resp_status) {
            if (index == this.selected_interest) {
              if (this.relevant.length > 0) {
                this.selected_interest = 0;
                this.pagination_message_id = null;
                this.relevant_messages = [];
                this.infiniteId += 1;
                this.page = 1;
              }
            }

            this.relevant.splice(index, 1);

            if (this.relevant.length < 1) {
              this.relevant_messages = [];
            }

            this.dialog = false;

            this.err_msg = 'Interest deleted.';
            this.snackbar = true;
          }
          else {
            this.err_msg = 'Unable to delete interest';
            this.snackbar = true;
          }
        });
    },
    /**
     * conf_dialog
     */
    conf_dialog(tag) {
      this.headline = "Delete Relevant Tag";
      this.message = "Are you sure you want to delete the " + tag + " Relevant tag?";
      this.delete_tag = tag;
      this.show_conf_dialog = true;
    },
    /**
     * open_dialog to add or remove interests
     */
    open_dialog() {
      this.dialog = true;
    },
    /**
     * remove_interest
     */
    remove_interest() {
      const index = this.relevant.indexOf(this.delete_tag);
      if (index > -1) {
        this.tag_delete(index);
      }
    },
    hideSearchBar() {
      this.$store.commit('setSearchBar', false);
    },
    /**
     * conf_dialog_closed
     */
    conf_dialog_closed() {
      this.show_conf_dialog = false;
    },
    /**
     * agree
     */
    agree() {
      this.show_conf_dialog = false;
      this.remove_interest();
    },
    /**
      * replaceUserIdMACRO 
      * While rendering Replace User tag with user name by user id for mention user
      */
    async replaceUserIdMACRO(message, tagStrArr) {
      var user_contact_list = await this.getUserContactList;
      return utility.replaceUserIdMicro(message, tagStrArr, user_contact_list);
    },
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str) {
      if (/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    }
  },
  watch: {
    new_interest(val) {
      let re = /[^A-Z0-9]/gi;
      if (re.test(val)) {
        this.snackbar = true;
        this.err_msg = 'Special characters are not allowed in tags';
      }
    },
    selected_interest() {
      if (this.selected_interest != -1) {
        this.pagination_message_id = null;
        this.relevant_messages = [];
        this.infiniteId += 1;
        this.page = 1;
      }
    },
  },
  directives: {
    plaintext: async function (el, binding, vnode) {
      let msg_obj = binding.value;
      let msg = entities.encode(msg_obj.text_msg);
      
      if(msg_obj && msg_obj.message_content_type == 1){ //media message 
        el.innerHTML = '';
        let icon = media_utility.listingMediaMessageFormat(msg, msg_obj);
        el.appendChild(icon);
        msg = el.innerHTML;
      }
      
      var tagStrArr = utility.getUserTags(msg)
      if (tagStrArr) {
        msg = await vnode.context.replaceUserIdMACRO(msg, tagStrArr);
      }
      el.innerHTML = msg;
    }
  }
}